import { useCompany } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';

import { appThemeAb, appThemeBcp } from './themes.constants';

export const useTheme = () => {
	const company = useCompany();

	return company === Company.ab ? appThemeAb : appThemeBcp;
};
